var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preloader'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('PartnerFooter',{attrs:{"main-settings":_vm.mainSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }